<template>
    <section class="section donors no-padding-top">
        <div class="container">
            <div class="row margin-bottom">
                <div class="col-12">
                    <div class="heading heading--primary heading--center">
                        <span class="heading__pre-title">Our Featured Sponsors</span>

                        <h2 class="heading__title no-margin-bottom">
                            <span>Please Support Those</span>
                            <br /><span>Who Support Us</span>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="slider-holder">
                        <div class="donors-slider donors-slider--style-1">
                            <div class="donors-slider__item">
                                <div class="donors-slider__img">
                                    <img src="@/assets/images/donor_1.png" alt="donor"/>
                                </div>
                            </div>

                            <div class="donors-slider__item">
                                <div class="donors-slider__img">
                                    <img src="@/assets/images/donor_2.png" alt="donor"/>
                                </div>
                            </div>

                            <div class="donors-slider__item">
                                <div class="donors-slider__img">
                                    <img src="@/assets/images/donor_3.png" alt="donor"/>
                                </div>
                            </div>

                            <div class="donors-slider__item">
                                <div class="donors-slider__img">
                                    <img src="@/assets/images/donor_4.png" alt="donor"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // msg: String
    }
}
</script>

<style scoped>
/*  */
</style>
